/**
 * For keeping constants that are possibly shared between components, or are
 * relating to components but are app-agnostic.
 */
export const pageSizeOptions = [10, 20, 50, 200];
export const brandColors = [
    'ocean',
    'ocean-dk',
    'red',
    'yellow',
    'green',
    'navy',
    'blue'
];
export const brandSizes = ['narrow', 'medium'];
export const brandLevels = ['primary', 'secondary', 'link-button'];
export const popoverPlacements = [
    'topLeft',
    'top',
    'topRight',
    'leftTop',
    'left',
    'leftBottom',
    'bottomLeft',
    'bottom',
    'bottomRight',
    'rightTop',
    'right',
    'rightBottom'
];
